import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'styled-components';
import PropertyValueWithTooltip from './PropertyValueWithTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCompactProperty = styled.div.withConfig({
  displayName: "CompactProperties__StyledCompactProperty",
  componentId: "t532g1-0"
})(["width:50%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-break:initial;"]);
const CompactProperties = ({
  object,
  objectTypeDefinition,
  items,
  getIsUngated,
  currencyFormatOptions
}) => {
  return /*#__PURE__*/_jsx(TFlex, {
    "data-test-id": "cdbc-properties-compact",
    direction: "row",
    wrap: "wrap",
    children: items.map((item, index) => {
      const name = item.definition.name;
      return /*#__PURE__*/_jsx(StyledCompactProperty, {
        "data-test-id": `cdbc-property-${index}`,
        "data-selenium-test": "card-property",
        "data-card-style": "COZY",
        children: /*#__PURE__*/_jsx(PropertyValueWithTooltip, {
          object: object,
          objectTypeDefinition: objectTypeDefinition,
          item: item,
          currencyFormatOptions: currencyFormatOptions,
          getIsUngated: getIsUngated,
          isCompact: true
        })
      }, name);
    })
  });
};
export default CompactProperties;